'use client';

import config from '@packages/config';
import type { DimensionFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { formatPrice } from '@packages/shared/src/utils/formatPrice/formatPrice';
import { useIntl } from 'react-intl';

export type TilesDimensionPriceProps = {
  /**
   * The GraphQL dimension data for the given product
   */
  data: NonNullable<DimensionFragmentFragment['values'][number]['price']>;
};

/**
 * TilesDimensionPrice is a component that displays the price of a product dimension in the variation select tiles.
 * It can display both the current price and the old price (if available) with appropriate formatting based on the shop's configuration.
 * */
export const TilesDimensionPrice = ({ data }: TilesDimensionPriceProps) => {
  const { currency, value, valueOld } = data;
  // we can not use getIntl() here, because order uses the component in the MiniDV, and therefore it needs to be a client component
  const { formatNumber, locale } = useIntl();
  const { priceFormat } = config;

  return (
    <div className="flex flex-col">
      {valueOld && (
        <span className="text-size-body-xs text-color-text-darktransparent line-through">
          {formatPrice(valueOld, currency, priceFormat, locale, formatNumber)}
        </span>
      )}
      <span className="text-size-body-xs">
        {formatPrice(value, currency, priceFormat, locale, formatNumber)}
      </span>
    </div>
  );
};
